import PrintIcon from "@mui/icons-material/Print";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, {useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";

import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useReactToPrint} from "react-to-print";

import {REPORT_TYPES} from "../../constants";

import {getReportById} from "../../services/requests/ApiRequests";
import {CONSTANT_PAYMENT_METHODS_DICT} from "../constants";

export default function Report() {
	let params = useParams();
	const {t} = useTranslation();

	const pageRef = useRef();

	let navigate = useNavigate();
	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});

	const [report, setReport] = React.useState({});
	const [loading, setLoading] = React.useState(true);

	const [searchParams] = useSearchParams();
	const searchParamsObj = Object.fromEntries(searchParams);
	const ridFromQuery = searchParams.get("rid");


	const handleScrollToTop = () => {
		window.scrollTo({
			top: 0,
		});
	};

	useEffect(() => {
		getReportById(params.reportId, searchParamsObj).then((data) => {
			setReport(data.data);
			setLoading(false);
		});

		handleScrollToTop()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function reportNumberResolve(num) {
		let num_str = num.toString();
		let pad = "000000";
		let result = pad.substring(0, pad.length - num_str.length) + num_str;
		return result;
	}

	if (loading) {
		return (
			<div align="center">
				<CircularProgress/>
			</div>
		);
	}

	return (
		<Box ref={pageRef} sx={{flexGrow: 1, marginTop: 5, marginLeft: 10}}>
			<Grid container spacing={2} align="left">
				<Grid item xs={5}>
					<Typography
						sx={{fontSize: 28}}
						color="pimary"
						gutterBottom
					>
						{t("viewing_report")}
					</Typography>
					<Button
						variant="text"
						color="secondary"
						onClick={() => {
							if (ridFromQuery) {
								navigate(`/acps/reports?rid=${ridFromQuery}`);
							} else {
								navigate("/acps/reports");
							}
						}}
					>
						&#60; {t("back_to_report_log")}
					</Button>
					<Divider/>
					<Grid container spacing={2} align="left">
						<Grid item xs={8}>
							<Typography
								sx={{fontSize: 20}}
								color="pimary"
								gutterBottom
							></Typography>
						</Grid>
						<Grid item xs={4}>
							<Typography
								sx={{fontSize: 20}}
								color="pimary"
								gutterBottom
							>
								{report.status}
							</Typography>
						</Grid>

						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								gutterBottom
							>
								{t("report_number")}
							</Typography>
						</Grid>
						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="pimary"
								gutterBottom
							>
								{report.soap_data.report}
							</Typography>
						</Grid>

						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								gutterBottom
							>
								{t("formed_date")}:
							</Typography>
						</Grid>
						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="pimary"
								gutterBottom
							>
								{report.soap_data.datetime.split("T")[0]}{" "}
								{report.soap_data.datetime.split("T")[1]}
							</Typography>
						</Grid>

						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								gutterBottom
							>
								{t("serial_number_kkm")}
							</Typography>
						</Grid>
						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="pimary"
								gutterBottom
							>
								{report.soap_data.card.number}
							</Typography>
						</Grid>

						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								gutterBottom
							>
								{t("address")}:
							</Typography>
						</Grid>
						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="pimary"
								gutterBottom
							>
								{report.soap_data.card.address}
							</Typography>
						</Grid>

						<Grid item xs={12} align="center">
							<Button
								variant="outlined"
								sx={{width: "75%"}}
								startIcon={<PrintIcon/>}
								onClick={handlePrint}
							>
								{t("print_report")}
							</Button>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={6}>
					<Card sx={{width: 375, "@media print": {margin: "0 auto"}}} ref={componentRef}>
						<CardContent>
							<Typography
								variant="h5"
								component="h5"
								color="text.secondary"
								align="center"
							>
								{report.soap_data.card.name}
							</Typography>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							>
								COD FISCAL: {report.soap_data.card.idnx}
							</Typography>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							>
								{report.soap_data.card.address}
							</Typography>

							{report.activity_type ? <Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							>
								{t(`activity_${report?.activity_type || ''}`)}
							</Typography> : null}

							{report.soap_data.type === REPORT_TYPES.X && (
								<Typography
									sx={{fontSize: 14}}
									color="text.secondary"
									align="center"
									gutterBottom
								>
									RAPORT X
								</Typography>
							)}

							{report.soap_data.type === REPORT_TYPES.Z && (
								<Typography
									sx={{fontSize: 14}}
									color="text.secondary"
									align="center"
									gutterBottom
								>
									ZILNIC RAPORT Z
								</Typography>
							)}
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							>
								VINZARI
							</Typography>


							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							></Typography>

							<Grid container spacing={2} align="left">
								<Grid item xs={6}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
										noWrap
									>
										Cant. bonurilor:
									</Typography>
								</Grid>
								<Grid item xs={6} align="right">
									<Typography
										sx={{
											fontSize: 14,
											wordBreak: "break-all",
											textAlign: "right",
										}}
										color="text.secondary"
										gutterBottom
									>
										{
											report.soap_data.daily.receipts
												.field[0].count
										}
										{/* количество чеков в отчёте \ за день */}
									</Typography>
								</Grid>
							</Grid>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							></Typography>
							{/* Payment types */}
							{report.soap_data.daily.payments.field.map(
								(payments, index) => {
									const paymentMethodName =
										CONSTANT_PAYMENT_METHODS_DICT[
											payments.type
											]
											? CONSTANT_PAYMENT_METHODS_DICT[
												payments.type
												].printName
											: payments.type;

									return (
										<React.Fragment key={index}>
											<Grid
												container
												spacing={2}
												align="left"
											>
												<Grid item xs={6}>
													<Typography
														sx={{fontSize: 14}}
														color="text.secondary"
														gutterBottom
														noWrap
													>
														{paymentMethodName}:
													</Typography>
												</Grid>
												<Grid item xs={6} align="right">
													<Typography
														sx={{
															fontSize: 14,
															wordBreak:
																"break-all",
															textAlign: "right",
														}}
														color="text.secondary"
														gutterBottom
													>
														{payments.total
															? payments.total
															: "*"}
													</Typography>
												</Grid>
											</Grid>
										</React.Fragment>
									);
								}
							)}

							{/* Service receipt */}
							<Grid container spacing={2} align="left">
								<Grid item xs={6}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
										noWrap
									>
										INTRARI SERTAR:
									</Typography>
								</Grid>
								<Grid item xs={6} align="right">
									<Typography
										sx={{
											fontSize: 14,
											wordBreak: "break-all",
											textAlign: "right",
										}}
										color="text.secondary"
										gutterBottom
									>
										{report.soap_data.daily.totals.in}
									</Typography>
								</Grid>
							</Grid>
							<Grid container spacing={2} align="left">
								<Grid item xs={6}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
										noWrap
									>
										IESIRI SERTAR:
									</Typography>
								</Grid>
								<Grid item xs={6} align="right">
									<Typography
										sx={{
											fontSize: 14,
											wordBreak: "break-all",
											textAlign: "right",
										}}
										color="text.secondary"
										gutterBottom
									>
										{report.soap_data.daily.totals.out}
									</Typography>
								</Grid>
							</Grid>
							<Grid container spacing={2} align="left">
								<Grid item xs={6}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
										noWrap
									>
										IN SAFEU:
									</Typography>
								</Grid>
								<Grid item xs={6} align="right">
									<Typography
										sx={{
											fontSize: 14,
											wordBreak: "break-all",
											textAlign: "right",
										}}
										color="text.secondary"
										gutterBottom
									>
										{report.soap_data.daily.totals.balance}
									</Typography>
								</Grid>
							</Grid>

							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							>
								GRUPE DE IMPOZIT
							</Typography>

							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							>
								- - - -
							</Typography>

							{report.soap_data.daily.taxes.field.map(
								(tax, index) => {
									const isNoWat = tax.code === "_";
									return (
										<React.Fragment key={index}>
											<Grid
												container
												spacing={2}
												align="left"
											>
												<Grid item xs={6}>
													<Typography
														sx={{fontSize: 14}}
														color="text.secondary"
														gutterBottom
														noWrap
													>
														Total{" "}
														{isNoWat
															? "Fără TVA"
															: tax.code}
														:
													</Typography>
												</Grid>
												<Grid item xs={6} align="right">
													<Typography
														sx={{
															fontSize: 14,
															wordBreak:
																"break-all",
															textAlign: "right",
														}}
														color="text.secondary"
														gutterBottom
													>
														{tax.cost}
													</Typography>
												</Grid>
											</Grid>

											<Grid
												container
												spacing={2}
												align="left"
											>
												<Grid item xs={6}>
													<Typography
														sx={{fontSize: 14}}
														color="text.secondary"
														gutterBottom
														noWrap
													>
														&nbsp;&nbsp;&nbsp;TVA{" "}
														{isNoWat
															? ""
															: tax.code}
														=
														{tax.code === "F" ||
														isNoWat
															? "Fără TVA"
															: `${tax.percent} %`}
														:
													</Typography>
												</Grid>
												<Grid item xs={6} align="right">
													<Typography
														sx={{
															fontSize: 14,
															wordBreak:
																"break-all",
															textAlign: "right",
														}}
														color="text.secondary"
														gutterBottom
													>
														{tax.rate}
													</Typography>
												</Grid>
											</Grid>

											<Grid
												container
												spacing={2}
												align="left"
											>
												<Grid item xs={6}>
													<Typography
														sx={{fontSize: 14}}
														color="text.secondary"
														gutterBottom
														noWrap
													>
														&nbsp;&nbsp;&nbsp;Total
														net{" "}
														{isNoWat
															? "Fără TVA"
															: tax.code}
														:
													</Typography>
												</Grid>
												<Grid item xs={6} align="right">
													<Typography
														sx={{
															fontSize: 14,
															wordBreak:
																"break-all",
															textAlign: "right",
														}}
														color="text.secondary"
														gutterBottom
													>
														{(
															tax.cost - tax.rate
														).toFixed(2)}
													</Typography>
												</Grid>
											</Grid>
										</React.Fragment>
									);
								}
							)}

							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							>
								- - - -
							</Typography>

							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							>
								TOTAL:
							</Typography>

							<Grid container spacing={2} align="left">
								<Grid item xs={6}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
										noWrap
									>
										SUMA TOTALA:
									</Typography>
								</Grid>
								<Grid item xs={6} align="right">
									<Typography
										sx={{
											fontSize: 14,
											wordBreak: "break-all",
											textAlign: "right",
										}}
										color="text.secondary"
										gutterBottom
									>
										{report.soap_data.daily.total}
									</Typography>
								</Grid>
							</Grid>
							<Grid container spacing={2} align="left">
								<Grid item xs={6}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
										noWrap
									>
										TOTAL TVA:
									</Typography>
								</Grid>
								<Grid item xs={6} align="right">
									<Typography
										sx={{
											fontSize: 14,
											wordBreak: "break-all",
											textAlign: "right",
										}}
										color="text.secondary"
										gutterBottom
									>
										{report.soap_data.daily.tax}
									</Typography>
								</Grid>
							</Grid>

							{/* z report improvements */}
							{report.soap_data.type === REPORT_TYPES.Z && (
								<>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										align="center"
										gutterBottom
									>
										* * * * *
									</Typography>
									<Grid container spacing={2} align="left">
										<Grid item xs={6}>
											<Typography
												sx={{fontSize: 14}}
												color="text.secondary"
												gutterBottom
												noWrap
											>
												TOTAL RULAJ MF:
											</Typography>
										</Grid>
										<Grid item xs={6} align="right">
											<Typography
												sx={{
													fontSize: 14,
													wordBreak: "break-all",
													textAlign: "right",
												}}
												color="text.secondary"
												gutterBottom
											>
												{report.soap_data.year.total}
											</Typography>
									</Grid>
								</Grid>
								<Grid container spacing={2} align="left">
										<Grid item xs={6}>
											<Typography
												sx={{fontSize: 14}}
												color="text.secondary"
												gutterBottom
												noWrap
											>
												TOTAL MF TVA:
											</Typography>
										</Grid>
										<Grid item xs={6} align="right">
											<Typography
												sx={{
													fontSize: 14,
													wordBreak: "break-all",
													textAlign: "right",
												}}
												color="text.secondary"
												gutterBottom
											>
												{report.soap_data.year.tax}
											</Typography>
										</Grid>
									</Grid>
								</>
							)}

							{report.soap_data.type === REPORT_TYPES.Z && (
								<>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										align="center"
										gutterBottom
									>
										* * * * *
									</Typography>
									<Grid container spacing={2} align="left">
										<Grid item xs={6}>
											<Typography
												sx={{fontSize: 14}}
												color="text.secondary"
												gutterBottom
												noWrap
											>
												RULAJ ANUAL :
											</Typography>
										</Grid>
										<Grid item xs={6} align="right">
											<Typography
												sx={{
													fontSize: 14,
													wordBreak: "break-all",
													textAlign: "right",
												}}
												color="text.secondary"
												gutterBottom
											>
												{report.soap_data.year.total}
											</Typography>
										</Grid>
									</Grid>
									<Grid container spacing={2} align="left">
										<Grid item xs={6}>
											<Typography
												sx={{fontSize: 14}}
												color="text.secondary"
												gutterBottom
												noWrap
											>
												ANUAL NET:
											</Typography>
										</Grid>
										<Grid item xs={6} align="right">
											<Typography
												sx={{
													fontSize: 14,
													wordBreak: "break-all",
													textAlign: "right",
												}}
												color="text.secondary"
												gutterBottom
											>
												{(
													report.soap_data.year
														.total -
													report.soap_data.year.tax
												).toFixed(2)}
											</Typography>
										</Grid>
									</Grid>
									<Grid container spacing={2} align="left">
										<Grid item xs={6}>
											<Typography
												sx={{fontSize: 14}}
												color="text.secondary"
												gutterBottom
												noWrap
											>
												ANUAL TVA:
											</Typography>
										</Grid>
										<Grid item xs={6} align="right">
											<Typography
												sx={{
													fontSize: 14,
													wordBreak: "break-all",
													textAlign: "right",
												}}
												color="text.secondary"
												gutterBottom
											>
												{report.soap_data.year.tax}
											</Typography>
										</Grid>
									</Grid>
								</>
							)}

							{report.soap_data.type === REPORT_TYPES.Z && (
								<>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										align="center"
										gutterBottom
									>
										* * * * *
									</Typography>
									<Grid container spacing={2} align="left">
										<Grid item xs={6}>
											<Typography
												sx={{fontSize: 14}}
												color="text.secondary"
												gutterBottom
												noWrap
											>
												RAPORT FISCAL ZILNIC
											</Typography>
										</Grid>
										<Grid item xs={6} align="right">
											<Typography
												sx={{
													fontSize: 14,
													wordBreak: "break-all",
													textAlign: "right",
												}}
												color="text.secondary"
												gutterBottom
											>
												{report.soap_data.report}
											</Typography>
										</Grid>
									</Grid>
								</>
							)}

							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							></Typography>

							{report.soap_data.type === REPORT_TYPES.X && (
								<Grid container spacing={2} align="left">
									<Grid item xs={6}>
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
											noWrap
										>
											RAPORT X
										</Typography>
									</Grid>
									<Grid item xs={6} align="right">
										<Typography
											sx={{
												fontSize: 14,
												wordBreak: "break-all",
												textAlign: "right",
											}}
											color="text.secondary"
											gutterBottom
										>
											{report.soap_data.report}
										</Typography>
									</Grid>
								</Grid>
							)}

							<Grid container spacing={2} align="left">
								<Grid item xs={12} align="left">
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										{reportNumberResolve(report._id)}
										{/* текущий номер отчёта */}
									</Typography>
								</Grid>
							</Grid>
							<Grid container spacing={2} align="left">
								<Grid item xs={6}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
										noWrap
									>
										Casier:
									</Typography>
								</Grid>
								<Grid item xs={6} align="right">
									<Typography
										sx={{
											fontSize: 14,
											wordBreak: "break-all",
											textAlign: "right",
										}}
										color="text.secondary"
										gutterBottom
									>
										{report.user.login || '-'}
									</Typography>
								</Grid>
							</Grid>
							<Grid container spacing={2} align="left">
								<Grid item xs={6}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
										noWrap
									>
										DATA:{" "}
										{
											report.soap_data.datetime.split(
												"T"
											)[0]
										}
									</Typography>
								</Grid>
								<Grid item xs={6} align="right">
									<Typography
										sx={{
											fontSize: 14,
											wordBreak: "break-all",
											textAlign: "right",
										}}
										color="text.secondary"
										gutterBottom
									>
										ORA:{" "}
										{
											report.soap_data.datetime.split(
												"T"
											)[1]
										}
									</Typography>
								</Grid>
							</Grid>
							<Grid container spacing={2} align="left">
								<Grid item xs={6}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
										noWrap
									>
										DATA MEV:{" "}
										{
											report?.soap_response?.datetime?.split(
												"T"
											)[0]
										}
									</Typography>
								</Grid>
								<Grid item xs={6} align="right">
									<Typography
										sx={{
											fontSize: 14,
											wordBreak: "break-all",
											textAlign: "right",
										}}
										color="text.secondary"
										gutterBottom
									>
										ORA MEV:{" "}
										{
											report?.soap_response?.datetime?.split(
												"T"
											)[1]
										}
									</Typography>
								</Grid>
							</Grid>

							<Grid container spacing={2} align="left">
								<Grid item xs={6}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
										noWrap
									>
										MEV ID:
									</Typography>
								</Grid>
								<Grid item xs={6}>
									<Typography
										sx={{
											fontSize: 14,
											wordBreak: "break-all",
											textAlign: "right",
										}}
										color="text.secondary"
										gutterBottom
										align="right"
									>
										{report?.soap_response?.id ||
											report?.soap_data?.id ||
											"N/A"}
									</Typography>
								</Grid>
							</Grid>

							<Grid container spacing={2} align="left">
								<Grid item xs={6}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
										noWrap
									>
										NUMARUL DE INREGISTRARE:
									</Typography>
								</Grid>
								<Grid item xs={6} align="right">
									<Typography
										sx={{
											fontSize: 14,
											wordBreak: "break-all",
											textAlign: "right",
										}}
										color="text.secondary"
										gutterBottom
									>
										{report.soap_data.card.number}
									</Typography>
								</Grid>
							</Grid>

							<Grid container spacing={2} align="left">
								<Grid item xs={6}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
										noWrap
									>
										SN:
									</Typography>
								</Grid>
								<Grid item xs={6} align="right">
									<Typography
										sx={{
											fontSize: 14,
											wordBreak: "break-all",
											textAlign: "right",
										}}
										color="text.secondary"
										gutterBottom
									>
										{report.soap_data.card.factory}
									</Typography>
								</Grid>
							</Grid>

							{/* QR */}
							{/* <Grid container spacing={2} align="center">
                                <Grid item xs={12}></Grid>
                                <Grid item xs={12}>
                                    <div id="qrcode">
                                        <QRCode
                                            size={80}
                                            value={`https://sift-mev.sfs.md/report/${
                                                report.soap_data.url
                                                    ? report.soap_data.url
                                                    : report.soap_data.id
                                            }/`}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12}></Grid>
                            </Grid> */}

							{report.soap_data.type !== REPORT_TYPES.Z && (
								<Grid container spacing={2} align="center">
									<Grid item xs={12}>
										<Typography
											sx={{fontSize: 14}}
											color="text.secondary"
											gutterBottom
										>
											*** BON DE SERVICIU ***
										</Typography>
									</Grid>
								</Grid>
							)}
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</Box>
	);
}
